import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mza-auth-mza-auth-service',
  template: `
    <p>
      mza-auth-service works!
    </p>
  `,
  styles: []
})
export class MzaAuthServiceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
